import { render, staticRenderFns } from "./Heptagon.vue?vue&type=template&id=594de128&"
import script from "./Heptagon.vue?vue&type=script&lang=js&"
export * from "./Heptagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports